/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m8.9443 10.7026.0088-.0044H6V17h1.226v-1.9248h1.6744c.6811 0 1.2261-.2197 1.6304-.6592.4043-.4394.6064-.9492.6064-1.5249 0-.5625-.2021-1.0679-.6064-1.5161-.4043-.4482-.9317-.6724-1.5865-.6724Zm-.101 3.2696.0088.0088H7.2172v-2.1622h1.6919c.2944 0 .5361.1099.7295.3252.1933.2154.29.4659.29.7515 0 .2857-.101.5361-.3032.7515-.2022.2153-.4614.3252-.7822.3252ZM15.4771 14.7983 16.9009 17h1.4238l-1.5644-2.3291c.4306-.1538.769-.4043 1.0107-.7559.2417-.3515.3647-.7382.3647-1.1645 0-.5317-.1977-1.0064-.5932-1.4238-.3955-.4175-.9185-.6241-1.5645-.6241h-3.0674v6.3018h1.2261v-2.2061h1.3404Zm-1.3448-1.081.0044-1.9072h1.8062c.29 0 .5273.0922.7163.2768.1889.1846.2812.4087.2812.668 0 .2724-.0966.501-.29.6855-.1934.1846-.4439.2769-.7559.2769h-1.7622Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 0a.75.75 0 0 0 0 1.5h1.25v1.5264c-2.4605.1736-4.687 1.195-6.389 2.774L3.5928 4.5321a.75.75 0 0 0-1.0606 1.0606l1.3037 1.3038C2.3751 8.7004 1.5 10.998 1.5 13.5 1.5 19.299 6.201 24 12 24s10.5-4.701 10.5-10.5c0-2.502-.8751-4.7996-2.3359-6.6034l1.3037-1.3038a.75.75 0 0 0-1.0606-1.0606L19.139 5.8003C17.437 4.2214 15.2105 3.2 12.75 3.0263V1.5H14A.75.75 0 0 0 14 0h-4Zm2 22.5c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'PRCount'
);
